module.exports = __webpack_public_path__ + "static/img_2-8c4d149e409dd102987e9163c770cac3.png";